import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { BETTING_LIMIT_ACTION_TYPE } from "../betting-limit.action";
import { BettingLimit, BettingLimitStatus, NetlossLimitState } from "../betting-limit.model";

const INITIAL_STATE: NetlossLimitState = {};

export function netlossLimitReducer(state = INITIAL_STATE, action: ActionWithPayload): NetlossLimitState {
	switch (action.type) {
		case BETTING_LIMIT_ACTION_TYPE.getNetlossLimitSuccess: {
			const bettingLimits: BettingLimit[] = action.payload;

			if (bettingLimits.length) {
				const activeNetlossLimit = bettingLimits.find((limit) => limit.status === BettingLimitStatus.Active);
				const queuedNetlossLimit = bettingLimits.find((limit) => limit.status === BettingLimitStatus.Queued);
				const hasAnyLimit = activeNetlossLimit !== undefined || queuedNetlossLimit !== undefined;

				return updateState(state, {
					...(hasAnyLimit ? { activeNetlossLimit } : {}),
					...(hasAnyLimit ? { queuedNetlossLimit } : {}),
					...(hasAnyLimit ? { bettingLimits } : {}),
				});
			}

			return state;
		}
		case BETTING_LIMIT_ACTION_TYPE.reset:
			return INITIAL_STATE;
		default:
			return state;
	}
}
